import { jsx as _jsx } from "react/jsx-runtime";
import { getVerticalizedTopBannerText } from "@faire/retailer-visitor-shared/components/Notifications/Components/__internal__/getVerticalizedTopBannerText";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var useFaireDirectMarketplaceIncentiveBannerTextContent = function() {
    var _useFaireDirectMarketplaceIncentive = useFaireDirectMarketplaceIncentive(), formattedDiscountPercentNumber = _useFaireDirectMarketplaceIncentive.formattedDiscountPercentNumber, daysRemaining = _useFaireDirectMarketplaceIncentive.daysRemaining, offerName = _useFaireDirectMarketplaceIncentive.offerName, isFaireDirectMarketplaceIncentive = _useFaireDirectMarketplaceIncentive.isFaireDirectMarketplaceIncentive, storeType = _useFaireDirectMarketplaceIncentive.storeType;
    if (isFaireDirectMarketplaceIncentive) {
        if (daysRemaining === 2) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "7+Ofz1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 1,
                                value: "daysRemainingNumber"
                            },
                            {
                                type: 0,
                                value: " days left!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "formattedDiscountPercentNumber"
                    },
                    {
                        type: 0,
                        value: " off."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    daysRemainingNumber: 2,
                    formattedDiscountPercentNumber: formattedDiscountPercentNumber
                }
            });
        }
        if (daysRemaining === 1) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "XO3Wr1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Last day!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "formattedDiscountPercentNumber"
                    },
                    {
                        type: 0,
                        value: " off."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedDiscountPercentNumber: formattedDiscountPercentNumber
                }
            });
        }
    }
    return getVerticalizedTopBannerText({
        formattedIncentivePercentNumber: formattedDiscountPercentNumber,
        offerName: offerName,
        storeType: storeType
    });
};
